import { useCallback, useEffect, useState } from "react";
import AcademyAPI from "../services/academyService";

export const useAcademyCourses = ({ category, enabled = true } = {}) => {
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(Boolean(enabled));
    const [error, setError] = useState(null);

    const loadCourses = useCallback(async () => {
        if (!enabled) {
            setLoading(false);
            setError(null);
            return;
        }
        setLoading(true);
        setError(null);

        try {
            const response = await AcademyAPI.getCourses(category);
            setCourses(response?.courses || []);
        } catch (err) {
            setError(err?.message || "Error cargando cursos");
            setCourses([]);
        } finally {
            setLoading(false);
        }
    }, [category, enabled]);

    useEffect(() => {
        loadCourses();
    }, [loadCourses]);

    return {
        courses,
        loading,
        error,
        reload: loadCourses,
    };
};
